import YesIcon from 'assets/images/yes-icon.svg';

import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';

import Logo from 'assets/images/logo.png';
import LoginLogo from 'assets/images/login-logo.png';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  scrollLogo: LoginLogo,
  cptCodesIcon: YesIcon,
  portalName: 'Seva Family Medicine',
  tokenName: 'sevaSubscriberToken',
  globalClass: 'seva-container',
  clientHeader: groupId,
  pricingType: 'standard-pricing',
  headerProps: {
    align: 'left',
  },
  homeTemplateProps: {
    heroSection: {
      variant: 1,
      primaryButtonProps: {},
      heroImage: '/images/home-images/home-banner-img.png',
      secondaryButtonProps: {
        portalId: '40118398',
        formId: 'ee057129-a9bf-4c4b-b8ce-9b0f057f0647',
      },
    },
    benefitsSection: {
      variant: 2,
      alignCard: 'left'
    },
    membershipComparisionSection: {
      enable: true,
    },
    subscriptionSection: {
      priority: 'bottom',
      titleProps: {
        color: 'secondary'
      },
      titleClasses: 'text-highlight',
      subTitleProps: {
        color: 'secondary'
      },
      subTitleClasses: 'pricing-subtitle',
      carouselResponsiveItems: {
        desktop: 3,
      },
      planCardProps: {
        buttonProps: {
          customSpace: 7,
          openHubspot: true,                  
          hubspotPortalId: '40118398',                  
          hubspotFormId: 'ee057129-a9bf-4c4b-b8ce-9b0f057f0647'
        },
      },
    },
    howItWorksSection: {
      heroImage: '/images/home-images/how-it-works.webp',
      clipPath: false,
      customNavPath: '/faq'
    },
    testimonialSection: {
      sectionClass: 'section-container',
      variant: 2,
      centerMode: true,
      heroImage: '/images/home-images/testimonial.webp',
      carouselResponsiveItem: {
        superLarge: 1,
        large: 1,
      }
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: true,
    bookAppointmentProps: {
      link: bookAppointmentLink,
      target: '_blank'
    },
  },
  checkoutSection: {
    intialfrequency: 'annual_billed_monthly'
  },
  savingsSummary: {},
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: false,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  footer: {
    logo: Logo
  },
  loginPage: {
    logo: LoginLogo,
    bannerImage: './images/login.webp',
  },
  theme: Theme
};

export default config;
